import React from 'react';
import { Alert, Box, Button, Typography } from '@mui/material';
import { Login as LoginIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import type { SportModuleState } from '@utils/sportModules';
import { STATE_LABELS } from '@utils/sportModules';

interface SportModuleComingSoonProps {
  sport: string;
  moduleLabel: string;
  state: SportModuleState;
  notes?: string | null;
}

const SportModuleComingSoon: React.FC<SportModuleComingSoonProps> = ({
  sport,
  moduleLabel,
  state,
  notes,
}) => {
  const navigate = useNavigate();
  const isBeta = state === 'beta';
  const isAdminOnly = state === 'admin_only';

  return (
    <Box sx={{ py: 6, textAlign: 'center', maxWidth: 520, mx: 'auto' }}>
      <Typography variant="h5" sx={{ fontWeight: 800, color: '#0f172a', mb: 1 }}>
        {moduleLabel} — {STATE_LABELS[state]}
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
        {isBeta
          ? `${moduleLabel} for ${sport} is in beta. Sign in to preview while we finish the rollout.`
          : isAdminOnly
            ? `${moduleLabel} for ${sport} is under admin preview.`
            : `${moduleLabel} for ${sport} is on the roadmap. Check back soon.`}
      </Typography>
      {notes && (
        <Alert severity="info" sx={{ mb: 2, textAlign: 'left' }}>
          {notes}
        </Alert>
      )}
      {isBeta && (
        <Button
          variant="contained"
          startIcon={<LoginIcon />}
          onClick={() => navigate('/login')}
          sx={{ textTransform: 'none', fontWeight: 700 }}
        >
          Sign in to preview
        </Button>
      )}
    </Box>
  );
};

export default SportModuleComingSoon;
